import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d87b26b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d87b26b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87b26b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchBar: require('/app/nuxt/components/HelpCenterPage/SearchBar/index.vue').default,SelfServices: require('/app/nuxt/components/HelpCenterPage/SelfServices/index.vue').default,FaqList: require('/app/nuxt/components/HelpCenterPage/FaqList/index.vue').default})
